export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/creative_writing.9921b80.svg";